import React, { useContext, useEffect, useRef, useState } from "react";
import profileIcon from "../../assets/profileIcon.svg";
import notificationIcon from "../../assets/notificationIcon.svg";
import DropdownMenu from "./DropdownMenu";
import Notifications from "./Notification";
import { Dropdown } from "react-bootstrap";
import classes from "./Navbar.module.scss";
import useWindowSize from "../../hooks/useWindowSize";
import SessionInfo from "./SessionInfo";
import { ClientTypes, OrgIdContext } from "../../store/orgId_context";
import MaintainerTools from "../mantainer/MaintainerTools";
import LanguageSelector from "../UI/LanguageSelector";
import QrCodeIcon from '@mui/icons-material/QrCode';
import Modal from 'react-bootstrap/Modal';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {QRCodeSVG} from 'qrcode.react';
import InfoIcon from '@mui/icons-material/Info';
import { OverlayTrigger,Tooltip } from "react-bootstrap";
import ApiIcon from '@mui/icons-material/Api';
import { useTranslation } from "react-i18next";
import ApiKeysModal from "../mantainer/ApiKeysModal";
import { ReactComponent as CopyBtn } from "../../assets/copy.svg";
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CircleIcon from '@mui/icons-material/Circle';
import HelpIcon from '@mui/icons-material/Help';
import { NotificationManager} from 'react-notifications';
import { E2Data } from "../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { Dialog, DialogActions, DialogContent, DialogTitle, Box, Typography } from "@mui/material";
import Button from "../UI/Button";

const e2DataNotifications = new E2Data("IL_AOrg_Notifications");
e2DataNotifications.take = 20;
e2DataNotifications.orderBy = "Created Desc";
e2DataNotifications.filter = 'Valid = true AND (ValidFrom <= now() OR ValidFrom = null) AND (ValidTo >= now() OR ValidTo = null) AND E2IF_TenantType = "O"';
const priority = {
  Error: 3,
  Warning: 2,
  Info: 1,
  null: 0,
  undefined: 0
};

const e2DataNotificationsStatic = new E2Data("IL_AOrg_Notifications");
e2DataNotificationsStatic.orderBy = "Created Desc";
e2DataNotificationsStatic.filter = 'Valid = true AND (ValidFrom <= now() OR ValidFrom = null) AND (ValidTo >= now() OR ValidTo = null) AND E2IF_TenantType = "A"';

const NavInfo = ({ clientData, sessionData }) => {
  const { width } = useWindowSize();
  const toggle = useRef();
  const {connectionKey, clientType,AccCustomer, sessionInfo, isMaintainer, connectionKeyMode} = useContext(OrgIdContext);
  const [show, setShow] = useState(false);
  const [qrdata, setQrdata] = useState("");
  const [qrdataconn, setQrdataConn] = useState("");
  const [showAPIKey, setShowAPIKey] = useState(false);
  const [notificationType, setNotificationType] = useState(null); //0|null,1,2,3 -> null| 'Info' | 'Warning' | 'Error'
  const [showNotification, setShowNotification] = useState(null);
  const {t} = useTranslation();

  const {isPending : isDataPending, data:notificationsList, refetch} = useQuery({
      queryKey: ['Data.GetEntityData', e2DataNotifications.GetParamsObject()],
      queryFn: () => e2DataNotifications.GetData(),
  })

  const {data:staticNotifications} = useQuery({
      queryKey: ['Data.GetEntityData', e2DataNotificationsStatic.GetParamsObject()],
      queryFn: () => e2DataNotificationsStatic.GetData(),
  })

  const onQrClick = () => {
    handleShow();
  }
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    //console.log(sessionInfo);
    if(!sessionInfo?.Extended?.ConnectionKey && !sessionInfo?.Extended?.DeviceData?.Id)
      return;
    let params={
        taxNo: sessionInfo?.Organization?.TaxNo,
        orgTitle: sessionInfo?.Organization?.Title,
        connectionKey: sessionInfo?.Extended?.ConnectionKey || sessionInfo?.Extended?.DeviceData?.Id,
        service : sessionInfo.BaseUrl
    }
    setQrdata(JSON.stringify(params));
    /*let params2 ={
        taxNo: sessionInfo?.Organization?.TaxNo,
        orgTitle: sessionInfo?.Organization?.Title,
        connectionKey: sessionInfo?.Extended?.ConnectionKey,
        service : sessionInfo.BaseUrl
    }
    setQrdataConn(JSON.stringify(params2));*/
  }, [connectionKey, sessionInfo]);

  const hasRunRef = useRef(false);
  useEffect(() => {
    if(window.DDDParser === undefined) return;
    if(!staticNotifications?.result?.data || staticNotifications?.result?.data.length ===0 || !notificationsList?.result?.data) return;
    if (hasRunRef.current) return;
    hasRunRef.current = true;
    let createNewNotification = [];
    const memory = {session : {...sessionInfo}}

    const interpreter = new window.DDDParser.DDDI_Interpreter(memory);
    staticNotifications.result?.data.forEach((notification) => {
      if(!notification?.Expression) return;
      const result = interpreter.execute(notification?.Expression);
      if(result) createNewNotification.push(notification);
    });
    let dateCreate = [];

    createNewNotification.forEach((newNotification) => {
      if(!notificationsList?.result?.data?.find(existingNotification => existingNotification.Source === newNotification.Id))
        dateCreate.push(newNotification);
    });
    createNewRecords(dateCreate);
  }, [staticNotifications,notificationsList]);

  const createNewRecords = async (notifications) => {
    if(notifications.length ===0) return;
    let data = new E2Data("IL_AOrg_Notifications");
    let createPromises = [];
    notifications.forEach((notification) => {
      let values = {...notification};
      delete values.Id;
      delete values.Created;
      delete values.E2IF_TenantType;
      values.Seen = false;
      values.Source = notification.Id;
      values.OrgName = sessionInfo?.Organization?.Title;
      data.values = values;
      createPromises.push(data.Create());
    });
    await Promise.all(createPromises);
    refetch();
  }

  useEffect(() => {
    if(!notificationsList) return;
    const data = notificationsList?.result?.data;
    if(!data || data.length ===0){
      setNotificationType(0);
      return;
    }
    let highestPriority = 0;
    data.forEach((notification) => {
      if(notification.Seen) return;
      const notifPriority = priority[notification.Type];
      if (notifPriority > highestPriority) {
        highestPriority = notifPriority;
      }
    });
    setNotificationType(highestPriority);
  }, [notificationsList]);

  const onNotificationsOpened = () => {
    setNotificationType(0);
    if(!notificationsList?.result?.data || notificationsList?.result?.data === 0) return;
    const seen = notificationsList?.result?.data?.find(n => !n.Seen);
    if(!seen) return;

    const data = new E2Data("IL_AOrg_Notifications");
    data.filter = "Seen = false AND E2IF_TenantType = 'O'";
    data.values = {
      Seen: true,
      DateTimeSeen: new Date().toISOString(),
      UserSeen: sessionInfo?.User?.Name
    };
    data.Modify().then((res) => {});
  }

  const findNotificationText = (value) => {
    return Object.keys(priority).find(key => priority[key] === value) || null;
  }

  const onItemClick = (notification) => {
    if(!notification || !notification.LongDescription) return;
    setShowNotification(notification)
  }

  const onApiKeyClick = () => {
    setShowAPIKey(true);
  }

  const clickDropdown = () => {
    if(toggle && toggle.current)
      toggle.current.click();
  }
  const copyAPIKey = () =>{
    navigator.clipboard.writeText(connectionKey);
    NotificationManager.success(``, t("Copied!"));
  }

  return (
    <div className={`d-flex ${classes.icons}`}>
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '90%', maxHeight: 600 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        onClose={() => setShowNotification(false)}
        open={!!showNotification}>
          <DialogTitle>
                {t("Notification Details")}
            </DialogTitle>
          <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {showNotification && (
              <>
                {/* Type and From on same line, small and subtle */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: '0.8rem',
                  color: 'rgba(0,0,0,0.6)',
                  marginBottom: '0.25rem'
                }}>
                  <span>{showNotification.Type || t("No Type")}</span>
                  {showNotification.From && <span>{t("From")}: {showNotification.From}</span>}
                </div>

                {/* Long text, takes the rest of the space */}
                {showNotification.LongDescription && (
                  <div
                    style={{
                      flex: 1,
                      overflowY: 'auto',
                      padding: '0.5rem',
                      border: '1px solid rgba(0,0,0,0.1)',
                      borderRadius: '6px',
                      backgroundColor: '#fafafa',
                      fontSize: '0.9rem',
                      lineHeight: 1.4
                    }}
                    dangerouslySetInnerHTML={{ __html: showNotification.LongDescription }}
                  />
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button className="ps-2 pe-2" autoFocus onClick={() => setShowNotification(false)}>
              {t("Close")}
            </Button>
          </DialogActions>
      </Dialog>
      {width > 768 && (<>
        {/* <div className="d-flex justify-content-center align-items-center position-relative flex-column">
          <div className={`d-flex ${classes.apibox} me-3`}  style={{color:"var(--main-blue)"}}>
            <span style={{color:"var(--main-orange)", marginRight:"0.3rem"}}>Api key:</span>
            {connectionKey}
            <CopyBtn style={{fill:"var(--main-blue)", transform:"scale(0.7)"}}/>
          </div>
        </div> */}
        {isMaintainer && <MaintainerTools/>} 
        {/* {!AccCustomer && clientType !== ClientTypes.AccService && connectionKey && width > 1000 && 
        <div className="d-flex justify-content-center align-items-center position-relative flex-column" style={{borderRight:"1px solid", color:"var(--main-orange)", marginRight: "1rem"}}>
          <span style={{color:"var(--main-orange)", marginRight:"0.3rem", alignSelf:"start"}}>
            {clientType !== ClientTypes.ISV && connectionKeyMode !== "PROD" && 
            <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("In test mode")}</Tooltip>}>
                <PanoramaFishEyeIcon style={{fontSize:"0.9rem", color:"var(--main-blue)", marginRight:"0.2rem"}}/>
            </OverlayTrigger> }
              
            {clientType !== ClientTypes.ISV && connectionKeyMode === "PROD" && 
            <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("In production")}</Tooltip>}>
                <CircleIcon style={{fontSize:"0.9rem", color:"green", marginRight:"0.2rem"}}/>
            </OverlayTrigger> }
            API key
            <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Currently in")}:<span className="fw-bold ms-2">{connectionKeyMode === "PROD" ? "Production" : "Test"}</span><br/>{t("This is your company's Connection Key. Invoices sent with this key go to the test environment only, until you set up the required authentication credentials for each distribution channels and switch the key to production mode. The key also includes your company's country info, which determines the e-invoice format and the tax authority portal used.")}</Tooltip>}>
                <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
            </OverlayTrigger>
          </span>
          <div className={`d-flex me-3 ${classes["apikey"]}`}  style={{color:"var(--main-blue)"}} onClick={copyAPIKey}>
            {connectionKey}
            <CopyBtn style={{fill:"var(--main-blue)", transform:"scale(0.7)"}}/>
          </div>
        </div>} */}
        {/* {!AccCustomer && clientType !== ClientTypes.AccService && <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Your API connection keys")}</Tooltip>}>
            <ApiIcon style={{fontSize:"2.5rem", padding:"0.2rem"}} className={classes["icon"]} onClick={onApiKeyClick}/>
        </OverlayTrigger>}
        <ApiKeysModal show={showAPIKey} onHide={() => setShowAPIKey(false)}/> */}
        <SessionInfo
          person={clientData.name}
          company={clientData.company}
          isDemo={sessionData?.Organization?.Demo}
          className="text-end me-2"
        />
        </>)}
      <LanguageSelector/>
      {/* <div className="d-flex justify-content-center align-items-center h-100">
        <QrCodeIcon fontSize="large" className={classes["qr-code-icon"]} onClick={onQrClick}/>
      </div> */}
      <Dropdown ref={toggle}>
        <Dropdown.Toggle 
          id="dropdown-basic"
          className={classes["toggle-btn"]}
          >
          {/* <img src={profileIcon} alt="profile" /> */}
          <svg className={classes["svg-icon"]} width="35" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.5 0C8.26333 0 0 8.26333 0 18.5C0 28.7367 8.26333 37 18.5 37C28.7367 37 37 28.7367 37 18.5C37 8.26333 28.7367 0 18.5 0ZM13.9367 11.2233C13.9367 8.75652 15.9922 6.78333 18.5 6.78333C21.0078 6.78333 23.0633 8.75659 23.0633 11.2233V12.909C23.0633 15.3758 21.0078 17.349 18.5 17.349C15.9922 17.349 13.9367 15.3757 13.9367 12.909V11.2233ZM26.8456 30.0111H10.1544C9.04437 30.0111 8.18118 29.1476 8.18118 28.1199C8.18118 23.1866 12.3746 19.1987 17.4723 19.1987H19.5279C24.6667 19.1987 28.819 23.2276 28.819 28.1199C28.819 29.1476 27.9558 30.0111 26.8457 30.0111H26.8456Z" />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-0">
          <DropdownMenu
            userName={clientData.name}
            companyName={clientData.company}
            mobileVersion={width <= 768}
            onItemClicked = {clickDropdown}
          />
        </Dropdown.Menu>
      </Dropdown>
      <Dropdown onToggle={(isOpen, event, metadata) => {
            if (isOpen) {
                onNotificationsOpened(); // mark all notifications as seen
            }
        }}>
        <Dropdown.Toggle id="dropdown-basic" className={classes["toggle-btn"]}>
          {/* <svg  className={classes["svg-icon"]} width="34" height="33" viewBox="0 0 34 33" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.8839 8.67902V10.3707C18.0613 10.3722 19.1904 10.8406 20.0232 11.6733C20.8556 12.506 21.3242 13.6348 21.3254 14.8123V17.3506H23.0174V14.8123C23.0156 13.1862 22.3687 11.6274 21.2188 10.4774C20.0691 9.32744 18.51 8.6808 16.8839 8.67902Z"/>
            <path d="M32.7467 25.3873C31.3445 25.384 30.0005 24.8244 29.0098 23.8319C28.0194 22.839 27.4628 21.4942 27.4622 20.0917V14.8122C27.4592 12.5005 26.6996 10.2532 25.2997 8.41333C23.8996 6.57356 21.9363 5.2423 19.7088 4.62257C20.2143 3.63907 20.1711 2.46343 19.5952 1.51953C19.019 0.575946 17.9929 0 16.887 0C15.7815 0 14.7554 0.575891 14.1792 1.51953C13.6033 2.46343 13.5601 3.63907 14.0656 4.62257C11.8381 5.24228 9.87477 6.57356 8.47467 8.41333C7.07479 10.2531 6.31522 12.5005 6.3122 14.8122V20.0917C6.3116 21.4942 5.75504 22.8391 4.76428 23.8319C3.77382 24.8245 2.42986 25.384 1.02759 25.3873C0.455327 25.4036 0 25.8723 0 26.4449C0 27.0171 0.455335 27.4858 1.02759 27.5021H32.7464C33.3186 27.4858 33.774 27.0171 33.774 26.4449C33.774 25.8723 33.3186 25.4037 32.7464 25.3873H32.7467ZM15.8257 3.17946C15.8257 2.75162 16.0834 2.36574 16.4787 2.20199C16.8739 2.03823 17.3289 2.12887 17.6313 2.43132C17.9341 2.73377 18.0244 3.1888 17.8606 3.58398C17.6969 3.97919 17.3113 4.23692 16.8835 4.23692C16.2997 4.23602 15.8266 3.76316 15.8257 3.1794L15.8257 3.17946ZM6.19413 25.3873C7.62085 23.995 8.42459 22.0852 8.42304 20.0916V14.8122C8.42304 11.7898 10.0356 8.9967 12.6531 7.48536C15.271 5.97403 18.4961 5.97403 21.1137 7.48536C23.7312 8.9967 25.3438 11.7897 25.3438 14.8122V20.0916C25.3422 22.0851 26.1459 23.995 27.5727 25.3873H6.19413Z"/>
            <path d="M16.8839 30.8854C16.3231 30.8842 15.7856 30.6612 15.3892 30.2645C14.9928 29.868 14.7698 29.3305 14.7692 28.7697H12.6535C12.6535 30.2811 13.46 31.6776 14.7689 32.4333C16.0778 33.1889 17.6901 33.1889 18.999 32.4333C20.3079 31.6776 21.1143 30.2811 21.1143 28.7697H18.9987C18.998 29.3305 18.7751 29.868 18.3786 30.2645C17.9822 30.6612 17.4447 30.8842 16.8839 30.8854Z"/>
          </svg> */}
          <div className={classes.iconWrapper2}>
              <svg  
                  className={classes["svg-icon"]}
                  width="34" height="33" 
                  viewBox="0 0 34 33" 
                  xmlns="http://www.w3.org/2000/svg"
              >
                  <path d="M16.8839 8.67902V10.3707C18.0613 10.3722 19.1904 10.8406 20.0232 11.6733C20.8556 12.506 21.3242 13.6348 21.3254 14.8123V17.3506H23.0174V14.8123C23.0156 13.1862 22.3687 11.6274 21.2188 10.4774C20.0691 9.32744 18.51 8.6808 16.8839 8.67902Z"/>
                  <path d="M32.7467 25.3873C31.3445 25.384 30.0005 24.8244 29.0098 23.8319C28.0194 22.839 27.4628 21.4942 27.4622 20.0917V14.8122C27.4592 12.5005 26.6996 10.2532 25.2997 8.41333C23.8996 6.57356 21.9363 5.2423 19.7088 4.62257C20.2143 3.63907 20.1711 2.46343 19.5952 1.51953C19.019 0.575946 17.9929 0 16.887 0C15.7815 0 14.7554 0.575891 14.1792 1.51953C13.6033 2.46343 13.5601 3.63907 14.0656 4.62257C11.8381 5.24228 9.87477 6.57356 8.47467 8.41333C7.07479 10.2531 6.31522 12.5005 6.3122 14.8122V20.0917C6.3116 21.4942 5.75504 22.8391 4.76428 23.8319C3.77382 24.8245 2.42986 25.384 1.02759 25.3873C0.455327 25.4036 0 25.8723 0 26.4449C0 27.0171 0.455335 27.4858 1.02759 27.5021H32.7464C33.3186 27.4858 33.774 27.0171 33.774 26.4449C33.774 25.8723 33.3186 25.4037 32.7464 25.3873H32.7467ZM15.8257 3.17946C15.8257 2.75162 16.0834 2.36574 16.4787 2.20199C16.8739 2.03823 17.3289 2.12887 17.6313 2.43132C17.9341 2.73377 18.0244 3.1888 17.8606 3.58398C17.6969 3.97919 17.3113 4.23692 16.8835 4.23692C16.2997 4.23602 15.8266 3.76316 15.8257 3.1794L15.8257 3.17946ZM6.19413 25.3873C7.62085 23.995 8.42459 22.0852 8.42304 20.0916V14.8122C8.42304 11.7898 10.0356 8.9967 12.6531 7.48536C15.271 5.97403 18.4961 5.97403 21.1137 7.48536C23.7312 8.9967 25.3438 11.7897 25.3438 14.8122V20.0916C25.3422 22.0851 26.1459 23.995 27.5727 25.3873H6.19413Z"/>
                  <path d="M16.8839 30.8854C16.3231 30.8842 15.7856 30.6612 15.3892 30.2645C14.9928 29.868 14.7698 29.3305 14.7692 28.7697H12.6535C12.6535 30.2811 13.46 31.6776 14.7689 32.4333C16.0778 33.1889 17.6901 33.1889 18.999 32.4333C20.3079 31.6776 21.1143 30.2811 21.1143 28.7697H18.9987C18.998 29.3305 18.7751 29.868 18.3786 30.2645C17.9822 30.6612 17.4447 30.8842 16.8839 30.8854Z"/>
              </svg>

              {/* Badge displayed depending on notificationType */}
              {notificationType && (
                  <div className={`${classes.badge2} ${classes[findNotificationText(notificationType)]}`}>
                      <span>!</span>
                  </div>
              )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-0" style={{width: "350px", maxHeight: "500px", overflowY: "auto"}}>
          <Notifications notifications={notificationsList} onItemClick={onItemClick}/>
        </Dropdown.Menu>
      </Dropdown>
      <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={handleClose}
          keyboard={false}
          show={show}
        >
          <Modal.Header className={classes.modalHeader}>
            <div className='w-100 d-flex '>
                <div>
                  Scan QR code to connect
                </div>
                <div className="ms-auto">
                  <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}}  onClick={handleClose} />
                </div>
              </div>
          </Modal.Header>
          <Modal.Body className={classes["modalBody"]}>
            <div /* className="d-flex justify-content-between" */>
            {qrdata && <>
              <div style={{alignSelf:"center", textAlign:"center"}}>
              <div className="mb-2">Scan to connect
                <OverlayTrigger placement="top" overlay={<Tooltip>{qrdata}</Tooltip>}>
                  <InfoIcon className="ms-2"/>
                </OverlayTrigger>
              </div>
              <QRCodeSVG value={qrdata} />
              </div>
            </>}
            {/* {sessionInfo?.Extended?.ConnectionKey && <>
              <div style={{alignSelf:"center", textAlign:"center"}}>
              <div className="mb-2">Scan to connect using connection key</div>
              <QRCodeSVG value={qrdataconn} />
              </div>
            </>}*/}
            </div> 
          </Modal.Body>
        </Modal>
    </div>
  );
};

export default NavInfo;
